import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { StorageProgress } from 'components/views/workspace/subscriptionPlan/SubscriptionPlan.styles';

export const StyledCompactContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.25),
  padding: theme.spacing(0.75, 1.5),
  flexShrink: 0,
  backgroundColor: theme.palette.grey[100],
  borderRadius: Number(theme.shape.borderRadius) * 20,
}));

export const StyledUsageContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== '$fullWidth',
})<{ $fullWidth: boolean }>(({ theme, $fullWidth }) => ({
  width: $fullWidth ? '100%' : 240,
  maxWidth: '100%',
  minWidth: 0,
  marginLeft: $fullWidth ? 0 : theme.spacing(1),
  marginRight: $fullWidth ? 0 : theme.spacing(1),
}));

export const StyledUsageProgress = styled(StorageProgress)(({ theme }) => ({
  backgroundColor: theme.palette.grey[300],
}));

export const StyledCompactUsageProgress = styled(StyledUsageProgress)({
  width: 64,
  height: 6,
  marginTop: 0,
  flexShrink: 0,
});

export const StyledUsageValue = styled(Typography)({
  whiteSpace: 'nowrap',
  fontVariantNumeric: 'tabular-nums',
});
